import { show, hide } from './actions'

const defaultTypeSuffixes = ['GET', 'POST', 'PUT', 'DELETE', 'SET', 'SUCCESS']

function loadingBarMiddleware(config = {}) {
  const typeSuffixes = config.typeSuffixes || defaultTypeSuffixes

  return ({ dispatch }) => next => action => {
    next(action)

    if (action.type === undefined) return

    const [GET, POST, PUT, DELETE, SET, SUCCESS] = typeSuffixes
    const isGet = `${GET}_`
    const isPost = `${POST}_`
    const isPut= `${PUT}_`
    const isDelete = `${DELETE}_`
    const isSet = `${SET}_`
    const isSuccess = `_${SUCCESS}`

    if (action.type.indexOf(isGet) !== -1 || action.type.indexOf(isPost) !== -1 || action.type.indexOf(isPut) !== -1 || action.type.indexOf(isDelete) !== -1) {
      dispatch(show())
    }
    else if (action.type.indexOf(isSet) !== -1 || action.type.indexOf(isSuccess) !== -1) {
      setTimeout(() => {
        dispatch(hide())
      }, 500)
    }
    // else if (action.type.indexOf(isRejected) !== -1) {
    //   dispatch(hide())
    //   dispatch({
    //     type: 'SEND_ERROR',
    //     error: action.error
    //   })
    // }
  }
}
export default loadingBarMiddleware
